import React from 'react';
import { SelectProps } from 'antd';
import { useHandbook } from '~/controllers/handbook';
import Select from './Select';

export interface SalesSelectProps extends SelectProps {
  filterCriteria: string;
}

const SalesFilterSelect: React.FC<SalesSelectProps> = (props) => {
  const handbook = useHandbook();

  const options = handbook.data?.handbooks
    ?.find((item) => item.key === props?.filterCriteria)
    ?.values?.map((item) => {
      // Change display label for SOB_DROPPED_JOURNEY to SOB_JOURNEY when showing channel list
      const displayLabel =
        props?.filterCriteria === 'channel' && item.localizedValue === 'SOB_DROPPED_JOURNEY'
          ? 'SOB_JOURNEY'
          : item.localizedValue;

      return {
        label: displayLabel,
        value: item.apiValue!,
        key: item.key,
      };
    });

  return (
    <Select
      loading={handbook.isLoading}
      disabled={handbook.isLoading}
      showSearch
      options={options}
      {...props}
    />
  );
};

export default SalesFilterSelect;
